export default __webpack_public_path__ + "img/24.e6542ed3.jpg";